const storageName = 'batteryWarning',
	batteryThreshold = 0.12, // = 12 %
	batteryCheckDelayInSeconds = 20,
	closeToggleDelayInSeconds = 1.5;

let batteryCheckInterval;
let batteryHasEventListener = false;

const elements = {
	batteryModal: () => document.querySelector('#battery-low'),
	batteryCloser: () => document.querySelector('#battery-low header button'),
	batteryToggle: () => document.querySelector('#battery-low footer .form-binary-input'),
};

const classNames = {
	show: 'battery--show',
};

const isVisible = () => elements.batteryModal().classList.contains(classNames.show);

const show = () => {
	if (isVisible()) {
		return;
	}
	elements.batteryModal().classList.add(classNames.show);

	// Send event to data layer
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: 'lowBatteryShow',
	});
};

const hide = (continueChecking = false) => {
	if (!continueChecking) {
		clearInterval(batteryCheckInterval);
	}
	elements.batteryModal().classList.remove(classNames.show);
};

const checkBatteryStatus = () => {
	navigator
		.getBattery()
		.then((battery) => {
			if (!battery.charging && battery.level < batteryThreshold) {
				show();

				if (!batteryHasEventListener) {
					battery.addEventListener('chargingchange', () => {
						if (battery.charging && isVisible()) {
							hide(true);
						}
					});
					batteryHasEventListener = true;
				}
			}
		})
		.catch((error) => {
			console.error('Battery status check failed', error);
			clearInterval(batteryCheckInterval);
		});
};

const runBatteryCheck = () => {
	if (navigator.getBattery && !localStorage.getItem(storageName) && !sessionStorage.getItem(storageName)) {
		batteryCheckInterval = setInterval(checkBatteryStatus, batteryCheckDelayInSeconds * 1000);
	}
};

/**
 * Closing the battery warning
 */

// 1. When the close button is clicked the battery warning should be hidden and not shown again for the current session
elements.batteryCloser().addEventListener('click', () => {
	sessionStorage.setItem(storageName, false);
	hide();
});

// 2. When the toggle is clicked the battery warning should be hidden and not shown again as long as the local storage is not cleared
elements.batteryToggle()?.addEventListener('change', () => {
	setTimeout(() => {
		localStorage.setItem(storageName, false);
		hide();
	}, closeToggleDelayInSeconds * 1000);
});

runBatteryCheck();

// Expose function to show battery warning message
window.showBatteryLowMessage = show;
